module.exports = __webpack_public_path__ + "img/circle_trash.6af202a2.png";